import { useTLang } from 'intl/intl';
import { useEffect, useRef, useState } from 'react';

import type { OrderDetailRawResp } from 'shared/infra';

interface InfoDictionary {
  key: keyof OrderDetailRawResp['user'];
  translationId: string;
}

const _BILLING_INFO: InfoDictionary[] = [
  { key: 'document_type_owner_value', translationId: 'order.clientName' },
  {
    key: 'document_type_description_label',
    translationId: 'order.documentType',
  },
  {
    key: 'document_type_description_value',
    translationId: 'order.documentNumber',
  },
  { key: 'bill_type', translationId: 'order.billType' },
  { key: 'billing_email', translationId: 'order.email' },
  { key: 'billing_address', translationId: 'address' },
  { key: 'billing_phone', translationId: 'telephone' },
];

export function useBillingInfo(userInfo: OrderDetailRawResp['user']) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const disclaimerText = useTLang({ id: 'order.legalInfoTitle' });
  const titleText = useTLang({ id: 'order.billingTitle' });

  useEffect(() => {
    if (contentRef.current) {
      const targetHeight = isExpanded ? contentRef.current.scrollHeight : 0;
      setHeight(targetHeight);
    }
  }, [isExpanded]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const infoItems = _BILLING_INFO
    .filter(val => !!userInfo[val.key])
    .map(item => ({
      key: item.key,
      value: userInfo[item.key]!,
      label: useTLang({ id: item.translationId }),
    }));

  return {
    isExpanded,
    height,
    contentRef,
    infoItems,
    disclaimerText,
    titleText,
    handleToggle,
  };
}
